<motif-modal-title variant="alt">
  <h3>{{ title }}</h3>
  <button motifIconButton aria-label="Close modal" [motif-modal-close]="true" [size]="buttonSizes.LARGE">
    <motif-icon class="motif-modal-header-close-icon" [iconFunction]="icon"></motif-icon>
  </button>
</motif-modal-title>
<motif-modal-content>
  <p>{{ text }}</p>
</motif-modal-content>

<motif-modal-actions>
  <button motifButton color="primary" [motif-modal-close]="true" aria-label="OK" role="button">OK</button>
</motif-modal-actions>
